/* global mymuesli */

(function () {

    /**
     * The model of an allergen.
     */
    class Allergen extends mymuesli.entities.AbstractBase {

        /**
         * Initializes a new Allergen model.
         *
         * @param plainObject The plain json (optional).
         */
        constructor (plainObject) {
            super({
                name: '',
                type: ''
            }, plainObject);
        }

    }

    mymuesli.entities.Allergen = Allergen;

}) ();
